export var HeadingTags;
(function (HeadingTags) {
    HeadingTags["P"] = "p";
    HeadingTags["H1"] = "h1";
    HeadingTags["H2"] = "h2";
    HeadingTags["H3"] = "h3";
    HeadingTags["H4"] = "h4";
    HeadingTags["H5"] = "h5";
    HeadingTags["H6"] = "h6";
})(HeadingTags || (HeadingTags = {}));
//# sourceMappingURL=heading-tags.js.map